export default "SELECT\n    prog_code\nFROM syzk_prog\nWHERE\n    prog_id IN (SELECT value FROM json_each($prog_ids));";